import { Component, OnInit } from "@angular/core";
import { ROUTES } from "./menu-items";
import { ROUTES_3 } from "./menu-items";
import { ROUTES_4 } from "./menu-items";
import { ROUTES_5 } from "./menu-items";
import { environment } from "../../../environments/environment";
import { AuthenticationService } from "../../services/authentication.service";
import { NotificationService } from "../../services/notification.service";
import { Events } from "../../services/events.service";
import { User } from "../../models/user";

declare var $: any;

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  showMenu = "";
  showSubMenu = "";
  showCardsMenu = false;
  showLocalsMenu = false;
  showAdsMenu = false;
  showRouteMenu = false;
  showInfoDestinationMenu = false;
  showResourcesMenu = false;
  showResourcesSeeMenu = false;
  showEventsMenu = false;
  showQueVerMenu = false;
  showQueHacerMenu = false;
  showEventsOtherMenu = false;
  clickedsubEvents = false;
  showHelpMenu = false;
  showPromocionesMenu = false;
  showDestinosMenu = false;
  showCityManagersMenu = false;
  showMaestrosMenu = false;
  showConfigsMenu = false;
  showCampaignsMenu = false;
  adminMenu = true;
  hasevents: any;
  hasruta: any;
  isPublicAdmin: any;
  public user: User;
  public sidebarnavItems: any[];

  constructor(
    private auth: AuthenticationService,
    private notificationService: NotificationService,
    private event: Events
  ) {
    this.event.subscribe("checkuser", () => {
      this.checkUser();
    });
  }

  // End open close
  ngOnInit() {
    this.user = this.auth.currentUserValue.user;

    if (this.user && !this.user.wizard) {
      this.checkUser();

      $(function () {
        $(".sidebartoggler").on("click", function () {
          if ($("#main-wrapper").hasClass("mini-sidebar")) {
            $("body").trigger("resize");
            $("#main-wrapper").removeClass("mini-sidebar");
          } else {
            $("body").trigger("resize");
            $("#main-wrapper").addClass("mini-sidebar");
          }
        });
      });
    }
  }

  // this is for the open close
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = "0";
    } else {
      this.showMenu = element;
    }
  }
  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = "0";
    } else {
      this.showSubMenu = element;
    }
  }

  checkUser() {
    if (this.user) {
      this.adminMenu = true;
      if (this.user.rolId !== 1) {
        if (this.user.rolId === 8) {
          this.sidebarnavItems = ROUTES_5.filter(
            (sidebarnavItem) => sidebarnavItem
          );
        }

        if (this.user.rolId === 3) {
          this.sidebarnavItems = ROUTES_3.filter(
            (sidebarnavItem) => sidebarnavItem
          );
        }

        if (this.user.rolId === 4 || this.user.rolId === 6) {
          this.adminMenu = false;
          this.sidebarnavItems = ROUTES_4.filter(
            (sidebarnavItem) => sidebarnavItem
          );
        }
      } else {
        this.sidebarnavItems = ROUTES.filter(
          (sidebarnavItem) => sidebarnavItem
        );
      }

      if (this.user.rolId === 6) {
        this.isPublicAdmin = true;
      } else {
        this.isPublicAdmin = false;
      }

      if (this.user.rutaId && this.user.rutaId > 0) {
        this.hasruta = 1;
      } else {
        this.hasruta = 0;
      }
      if (this.user.cliente && this.user.cliente.hasevents === 0) {
        this.hasevents = 0;
      } else {
        this.hasevents = 1;
      }
    }
  }

  public checkPlan(): boolean {
    return !this.user.planId || this.user.planId === environment.planBasicId;
  }

  public messagePlanBasic(event: Event): void {
    if (this.checkPlan()) {
      event.preventDefault();

      this.notificationService.warning(
        "La cuenta Basic no puede generar usuarios para la app Staff y deben usuar el mismo usuario de entrada al panel"
      );
    }

    this.close(event);
  }

  showItems(item, type) {
    if (type === 1 && item.subvisible === false) {
      this.closeMenu();
    }
    if (item.subvisible) {
      item.subvisible = !item.subvisible;
    } else {
      item.subvisible = true;
    }
  }

  showMaestros() {
    if (!this.clickedsubEvents) {
      this.showMaestrosMenu = !this.showMaestrosMenu;
    }
    this.clickedsubEvents = false;
  }

  showCampaigns() {
    if (!this.clickedsubEvents) {
      this.showCampaignsMenu = !this.showCampaignsMenu;
    }
    this.clickedsubEvents = false;
  }

  showConfigs() {
    this.showConfigsMenu = !this.showConfigsMenu;
    this.clickedsubEvents = !this.clickedsubEvents;
  }

  showHelp() {
    this.showHelpMenu = !this.showHelpMenu;
  }

  showPromociones() {
    this.showPromocionesMenu = !this.showPromocionesMenu;
  }

  showDestinos() {
    this.showDestinosMenu = !this.showDestinosMenu;
  }

  showCityManagers() {
    this.showCityManagersMenu = !this.showCityManagersMenu;
  }

  showAds() {
    this.showAdsMenu = !this.showAdsMenu;
  }

  showCards() {
    this.showCardsMenu = !this.showCardsMenu;
  }

  showLocals() {
    this.showLocalsMenu = !this.showLocalsMenu;
  }

  showRoute() {
    this.showRouteMenu = !this.showRouteMenu;
  }

  showInfoDestination() {
    this.showInfoDestinationMenu = !this.showInfoDestinationMenu;
  }

  showResources() {
    this.showResourcesMenu = !this.showResourcesMenu;
  }

  showResourcesSee() {
    this.showResourcesSeeMenu = !this.showResourcesSeeMenu;
  }

  showEvents() {
    this.showEventsMenu = !this.showEventsMenu;
    this.clickedsubEvents = !this.clickedsubEvents;
  }

  showQueVer() {
    this.showQueVerMenu = !this.showQueVerMenu;
  }

  showQueHacer() {
    if (!this.clickedsubEvents) {
      this.showQueHacerMenu = !this.showQueHacerMenu;
    }

    this.clickedsubEvents = false;
  }

  showEventsOther() {
    this.showEventsOtherMenu = !this.showEventsOtherMenu;
  }

  close(e: Event) {
    e.stopPropagation();

    $(".visible").removeClass("visible");
  }

  closeMenu() {
    for (let i = 0; i < this.sidebarnavItems.length; i++) {
      this.sidebarnavItems[i].subvisible = false;
      for (let j = 0; j < this.sidebarnavItems[i].submenu.length; j++) {
        this.sidebarnavItems[i].submenu[j].subvisible = false;
      }
    }
  }
}
